import { useEffect } from 'react'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'
import { cloneDeep } from 'lodash'
import { image } from '../../../../../utils/data/baseUrl'
import { useModalsDataActions } from '../../../../../hooks/useModalsDataActions'
import useFindAchievementById from '../../../../../hooks/shared/achievements/useFindAchievementById'
import { IMAGE, TEXT } from '../../../../modals/universalModal'
import { newAchievementContent } from '../../../../../constants/copyright-modals'
import { useAppState, useChallenges, useOnboarding } from '../../../../../redux/reducer/content'
import { MAIN } from '../../../../../constants/shared/states/names'
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle'
import { gtmFunctions } from '../../../../../constants/analytics/GTM'

const {
  components: [title, buttons],
  modalProps,
} = newAchievementContent

export default function useHandleAchievements() {
  const { icons, newIcons } = useChallenges()
  const state = useAppState()
  const findAchievementById = useFindAchievementById()
  const callbacks = useApplicationCallbacks()
  const { addModal } = useModalsDataActions()
  const { achievementsModalsVisible } = useOnboarding()

  const gameTamagotchiBeauties = useFeatureToggle('gameTamagotchiBeauties')

  useEffect(() => {
    if (!newIcons?.length || state !== MAIN || !achievementsModalsVisible) return

    if (gameTamagotchiBeauties) {
      callbacks.getBeautiesBalance()
    }

    newIcons?.forEach?.((iconId) => {
      const {
        modal_description_win,
        icon,
        grade,
        title: achievementTitle,
      } = findAchievementById(iconId, icons) ?? {}

      const buttonsWithGtm = {
        ...buttons,
        props: {
          ...buttons.props,
          buttons: buttons.props.buttons.map((btn) => ({
            ...btn,
            onClick: () =>
              gtmFunctions.GTMAchievementsModal({
                name: achievementTitle,
                achievement_level: grade,
              }),
          })),
        },
      }

      addModal({
        type: 'universalModal',
        props: {
          modalProps,
          components: [
            {
              list: [
                {
                  type: IMAGE,
                  props: {
                    img: icon,
                    modifier: 'min-width',
                    extraIcon: image(`challenges/lvl-${grade ?? 1}.png`),
                  },
                },
                cloneDeep(title),
                {
                  type: TEXT,
                  props: {
                    isUseTranslation: false,
                    value: modal_description_win,
                  },
                },
                cloneDeep(buttonsWithGtm),
              ],
            },
          ],
        },
      })
    })

    callbacks.clearNewIcons(newIcons)
  }, [newIcons, icons, state, achievementsModalsVisible])
}
